import React, { Component } from 'react'
import styled from 'styled-components'
import { Shape } from './StyledComponents'
import Toast from './Toast'
import { find, sortBy, isEmpty, xor, reverse } from 'lodash'
import axios from 'axios'
import { API_URL } from '../constants'
import Cookies from 'js-cookie'
const TopWrap = styled.div`
  padding: ${({ padding }) => padding || '10px 16px 0'};
  width: 100%;
  background: ${({ background }) => background || 'transparent'};
  overflow-y: hidden;
  overflow-x: scroll;
`
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
  width: 100%;
  min-width: 100%;
  overflow: scroll;
  & > div {
    background: #fff;
    margin: 0 8px 8px 0;
    white-space: nowrap;
  }
  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    opacity: 0;
    display: none;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
    background-color: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: transparent;
    outline: 1px solid transparent;
    border-radius: 3px;
  }
`

class SecondaryHeader extends Component {
  static defaultProps = {
    clicked: () => {}
  }
  state = {
    selectedStores: [],
    grocers: [],
    openToast: false
  }
  async componentDidMount() {
    await this.fetchStores()
    this.setState({ selectedStores: Cookies.getJSON('selectedStores') })
  }
  fetchStores = async () => {
    try {
      const { data } = await axios.get(`${API_URL}/grocers`)
      let selectedStores = Cookies.getJSON('selectedStores')
      if (isEmpty(selectedStores) || !selectedStores) {
        selectedStores = data.map(item => item.storeName).filter(item => item !== 'Insta_Wegmans')
        Cookies.set('selectedStores', selectedStores, { path: '/', expires: 365 })
      }

      const grocers = reverse(sortBy(data, item => selectedStores.indexOf(item.storeName)))
      this.setState({ grocers })
    } catch (error) {
      console.log(error)
    }
  }
  chipHandler = e => {
    const selectedChips = Cookies.getJSON('selectedStores')

    Cookies.set('selectedStores', xor(selectedChips, [e]), { path: '/', expires: 365 })
    const grocers = reverse(sortBy(this.state.grocers, item => xor(selectedChips, [e]).indexOf(item.storeName)))
    this.setState({ selectedStores: xor(selectedChips, [e]), grocers, openToast: true })
    this.props.clicked()
  }

  handleClose = async (event, reason) => {
    await this.setState({ openToast: false })
  }

  render() {
    const { selectedStores, grocers, openToast } = this.state
    const { clicked, ...props } = this.props
    return (
      <TopWrap {...props}>
        <Wrapper>
          <React.Fragment>
            {grocers.map((item, key) => {
              if (item.storeName === 'Insta_Wegmans') {
                return null
              } else {
                return (
                  <Shape
                    key={key}
                    width="100%"
                    margin={'0 8px 0 0 !important'}
                    onClick={() => this.chipHandler(item.storeName)}
                    selected={find(selectedStores, value => value === item.storeName)}>
                    <img src={item.imageUrl} alt={item.storeName} height="18" />
                  </Shape>
                )
              }
            })}
          </React.Fragment>
        </Wrapper>
        <Toast open={openToast} message="Grocery Filter Changed" onClose={this.handleClose} />
      </TopWrap>
    )
  }
}

export default SecondaryHeader



// WEBPACK FOOTER //
// ./src/components/SecondaryHeader.js